/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc メッセージフレーム
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<transition name="message-frame-fade">
  <li class="fc-message-frame" :class="[messageDistributionClass]">
    <transition name="message-unread-sign-fade">
      <div v-show="unread" class="message-unread-sign">
        <div class="message-unread-sign-label">
          {{$t('ここから未読')}}
        </div>
      </div>
    </transition>
    <el-container>
      <el-aside class="messaga-avatar-oprator-wrapper" width="auto">
        <div :class="[iconSnsStaffClass]"></div>
      </el-aside>
      <el-main class="message-main">
        <el-container class="message-wrapper">
          <component :is="messageComponent" ref="messageComponent" :messageInfo="messageInfo" :disabled="disabled" :requesting="requesting" :lastSnsMessage="lastSnsMessage" @sendAnswerMessage="sendAnswerMessageHandler" @waitChatReceive="waitChatReceiveHandler"
            @openSurvey="openSurveyHandler"></component>
        </el-container>
        <el-footer class="message-timestamp" height="auto">{{messageSendDate}}</el-footer>
      </el-main>
    </el-container>
  </li>
</transition>
</template>

<script>
import {
  Container,
  Footer,
  Main,
  Aside
} from 'element-ui'
import DateUtil from '@/utils/DateUtil'
import FcMessageUtil from '@/utils/FcMessageUtil'
import MessageInfoConst from '@/constants/MessageInfoConst'
import FcTextMessage from './FcTextMessage'
import FcConfirmMessage from './FcConfirmMessage'
import FcButtonListMessage from './FcButtonListMessage'
import FcImageUrlMessage from './FcImageUrlMessage'
import FcSurveyRequestMessage from './FcSurveyRequestMessage'

export default {
  name: 'FcMessageFrame',
  components: {
    'el-container': Container,
    'el-footer': Footer,
    'el-main': Main,
    'el-aside': Aside,
    FcTextMessage,
    FcConfirmMessage,
    FcButtonListMessage,
    FcImageUrlMessage,
    FcSurveyRequestMessage
  },
  props: [
    /**
     * メッセージ情報
     */
    'messageInfo',
    /**
     * 無効状態
     */
    'disabled',
    /**
     * リクエスト中か
     */
    'requesting',
    /**
     * 最後のメッセージか
     */
    'lastSnsMessage'
  ],
  data() {
    return {
      /**
       * 未読か
       * @type {Boolean}
       */
      unread: false
    }
  },
  mounted() {
    this.optimizeMessageInfo()
  },
  updated() {
    this.optimizeMessageInfo()
  },
  destroyed() {
    if (this.messageInfo) {
      this.messageInfo.messageFrame = this
    }
  },
  computed: {
    /**
     * メッセージ内容部分で使用するメッセージ部品を取得します。
     * @return メッセージ部品
     */
    messageComponent() {
      if (this.messageInfo.messageType === MessageInfoConst.MESSAGE_TYPE_TEXT) {
        return 'fc-text-message'
      } else if (this.messageInfo.messageType === MessageInfoConst.MESSAGE_TYPE_CONFIRM || this.messageInfo.messageType === MessageInfoConst.MESSAGE_TYPE_SWITCH_CONFIRM) {
        return 'fc-confirm-message'
      } else if (this.messageInfo.messageType === MessageInfoConst.MESSAGE_TYPE_BUTTON_LIST) {
        return 'fc-button-list-message'
      } else if (this.messageInfo.messageType === MessageInfoConst.MESSAGE_TYPE_IMAGE_URL) {
        return 'fc-image-url-message'
      } else if (this.messageInfo.messageType === MessageInfoConst.MESSAGE_TYPE_SURVEY_REQUEST) {
        return 'fc-survey-request-message'
      }
    },
    /**
     * メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）を取得します。
     * @return {String} メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）
     */
    messageDistributionClass() {
      return FcMessageUtil.messageDistributionClass(this.messageInfo)
    },
    /**
     * 送信日時（表示用）を取得します。
     * @return {String} 送信日時（表示用）
     */
    messageSendDate() {
      return DateUtil.formatDate(new Date(this.messageInfo.sendDate), this.$t('hh:mm'))
    },
    /**
     * SNS担当者アイコンのクラスを取得します。
     * @return {String}
     */
    iconSnsStaffClass() {
      if (this.messageInfo.snsStaffId === MessageInfoConst.SNS_STAFF_ID_BOT) {
        return 'icoBot'
      } else {
        return 'icoOperator'
      }
    }
  },
  methods: {
    /**
     * メッセージ情報を最適化します
     */
    optimizeMessageInfo() {
      this.unread = this.messageInfo.unread
      this.messageInfo.messageFrame = this
    },
    /**
     * 送信処理
     * @param  {Object} sendMessageInfo 送信メッセージ情報
     */
    sendAnswerMessageHandler(sendMessageInfo) {
      this.$emit('sendAnswerMessage', sendMessageInfo)
    },
    /**
     * チャット配信待ち処理
     */
    waitChatReceiveHandler() {
      this.$emit('waitChatReceive')
    },
    /**
     * 「アンケートに答える」処理
     */
    openSurveyHandler() {
      this.$emit('openSurvey')
    }
  }
}
</script>

<style scoped>
.fc-message-frame {
  list-style: none;
  margin-bottom: 14px;
}

.message-timestamp {
  font-size: smaller;
  color: gray;
  padding: 0;
  margin-bottom: 6px;
}

.my-message .message-wrapper {
  direction: rtl;
}

.my-message .message-timestamp {
  text-align: right;
}

.client-system-message .message-timestamp,
.client-system-message .messaga-avatar-oprator-wrapper {
  display: none;
}

.message-frame-fade-enter-active,
.message-frame-fade-leave-active {
  transition: opacity .5s;
}

.message-frame-fade-enter,
.message-frame-fade-leave-to {
  opacity: 0;
}

.messaga-avatar-oprator-wrapper {
  overflow: visible;
}

.my-message .messaga-avatar-oprator-wrapper {
  display: none;
}

.message-main {
  padding: 0;
}

.message-unread-sign {
  transition: height 1.5s;
  height: 30px;
}

.message-unread-sign-label {
  transition: opacity 1s;
}

.message-unread-sign-fade-leave-to {
  height: 0px;
  overflow: hidden;
}

.message-unread-sign-fade-leave-to .message-unread-sign-label {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/message/FcMessageFrame.vue